const RECONNECT = 'DIRECT_LINE/RECONNECT';
const RECONNECT_FULFILLED = `${RECONNECT}_FULFILLED`;
const RECONNECT_FULFILLING = `${RECONNECT}_FULFILLING`;
const RECONNECT_PENDING = `${RECONNECT}_PENDING`;
const RECONNECT_REJECTED = `${RECONNECT}_REJECTED`;

export { RECONNECT, RECONNECT_FULFILLED, RECONNECT_FULFILLING, RECONNECT_PENDING, RECONNECT_REJECTED };
